import subOrganizationsActions from '../../entities/subOrganizations/actions';

export const TYPES = {
  LOAD_REQUEST: 'subOrganizations/LOAD_REQUEST',
  LOAD_REQUEST_SUCCESS: 'subOrganizations/LOAD_REQUEST_SUCCESS',
  LOAD_REQUEST_ERROR: 'subOrganizations/LOAD_REQUEST_ERROR',
  CLEAR_STATE: 'subOrganizations/CLEAR_STATE',
};

export const search = options => async (dispatch) => {
  dispatch({ type: TYPES.LOAD_REQUEST });

  try {
    const { data } = await dispatch(subOrganizationsActions.getAllSubOrgs(options));

    const subOrgIds = [...new Set(data?.content?.map(val => val?.id))];

    dispatch({ type: TYPES.LOAD_REQUEST_SUCCESS, payload: { subOrgIds } });
  } catch (error) {
    dispatch({ type: TYPES.LOAD_REQUEST_ERROR, payload: error });
  }
};

export const clearState = () => (dispatch) => {
  dispatch({ type: TYPES.CLEAR_STATE });
};

export default {
  TYPES,
  search,
  clearState,
};
